(function(factory) {
  typeof define === "function" && define.amd ? define(factory) : factory();
})(function() {
  "use strict";
  function _regeneratorRuntime() {
    _regeneratorRuntime = function() {
      return e;
    };
    var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function(t2, e2, r2) {
      t2[e2] = r2.value;
    }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag";
    function define2(t2, e2, r2) {
      return Object.defineProperty(t2, e2, {
        value: r2,
        enumerable: true,
        configurable: true,
        writable: true
      }), t2[e2];
    }
    try {
      define2({}, "");
    } catch (t2) {
      define2 = function(t3, e2, r2) {
        return t3[e2] = r2;
      };
    }
    function wrap(t2, e2, r2, n2) {
      var i2 = e2 && e2.prototype instanceof Generator ? e2 : Generator, a2 = Object.create(i2.prototype), c2 = new Context(n2 || []);
      return o(a2, "_invoke", {
        value: makeInvokeMethod(t2, r2, c2)
      }), a2;
    }
    function tryCatch(t2, e2, r2) {
      try {
        return {
          type: "normal",
          arg: t2.call(e2, r2)
        };
      } catch (t3) {
        return {
          type: "throw",
          arg: t3
        };
      }
    }
    e.wrap = wrap;
    var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {};
    function Generator() {
    }
    function GeneratorFunction() {
    }
    function GeneratorFunctionPrototype() {
    }
    var p = {};
    define2(p, a, function() {
      return this;
    });
    var d = Object.getPrototypeOf, v = d && d(d(values([])));
    v && v !== r && n.call(v, a) && (p = v);
    var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
    function defineIteratorMethods(t2) {
      ["next", "throw", "return"].forEach(function(e2) {
        define2(t2, e2, function(t3) {
          return this._invoke(e2, t3);
        });
      });
    }
    function AsyncIterator(t2, e2) {
      function invoke(r3, o2, i2, a2) {
        var c2 = tryCatch(t2[r3], t2, o2);
        if ("throw" !== c2.type) {
          var u2 = c2.arg, h2 = u2.value;
          return h2 && "object" == typeof h2 && n.call(h2, "__await") ? e2.resolve(h2.__await).then(function(t3) {
            invoke("next", t3, i2, a2);
          }, function(t3) {
            invoke("throw", t3, i2, a2);
          }) : e2.resolve(h2).then(function(t3) {
            u2.value = t3, i2(u2);
          }, function(t3) {
            return invoke("throw", t3, i2, a2);
          });
        }
        a2(c2.arg);
      }
      var r2;
      o(this, "_invoke", {
        value: function(t3, n2) {
          function callInvokeWithMethodAndArg() {
            return new e2(function(e3, r3) {
              invoke(t3, n2, e3, r3);
            });
          }
          return r2 = r2 ? r2.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
      });
    }
    function makeInvokeMethod(e2, r2, n2) {
      var o2 = h;
      return function(i2, a2) {
        if (o2 === f)
          throw Error("Generator is already running");
        if (o2 === s) {
          if ("throw" === i2)
            throw a2;
          return {
            value: t,
            done: true
          };
        }
        for (n2.method = i2, n2.arg = a2; ; ) {
          var c2 = n2.delegate;
          if (c2) {
            var u2 = maybeInvokeDelegate(c2, n2);
            if (u2) {
              if (u2 === y)
                continue;
              return u2;
            }
          }
          if ("next" === n2.method)
            n2.sent = n2._sent = n2.arg;
          else if ("throw" === n2.method) {
            if (o2 === h)
              throw o2 = s, n2.arg;
            n2.dispatchException(n2.arg);
          } else
            "return" === n2.method && n2.abrupt("return", n2.arg);
          o2 = f;
          var p2 = tryCatch(e2, r2, n2);
          if ("normal" === p2.type) {
            if (o2 = n2.done ? s : l, p2.arg === y)
              continue;
            return {
              value: p2.arg,
              done: n2.done
            };
          }
          "throw" === p2.type && (o2 = s, n2.method = "throw", n2.arg = p2.arg);
        }
      };
    }
    function maybeInvokeDelegate(e2, r2) {
      var n2 = r2.method, o2 = e2.iterator[n2];
      if (o2 === t)
        return r2.delegate = null, "throw" === n2 && e2.iterator.return && (r2.method = "return", r2.arg = t, maybeInvokeDelegate(e2, r2), "throw" === r2.method) || "return" !== n2 && (r2.method = "throw", r2.arg = new TypeError("The iterator does not provide a '" + n2 + "' method")), y;
      var i2 = tryCatch(o2, e2.iterator, r2.arg);
      if ("throw" === i2.type)
        return r2.method = "throw", r2.arg = i2.arg, r2.delegate = null, y;
      var a2 = i2.arg;
      return a2 ? a2.done ? (r2[e2.resultName] = a2.value, r2.next = e2.nextLoc, "return" !== r2.method && (r2.method = "next", r2.arg = t), r2.delegate = null, y) : a2 : (r2.method = "throw", r2.arg = new TypeError("iterator result is not an object"), r2.delegate = null, y);
    }
    function pushTryEntry(t2) {
      var e2 = {
        tryLoc: t2[0]
      };
      1 in t2 && (e2.catchLoc = t2[1]), 2 in t2 && (e2.finallyLoc = t2[2], e2.afterLoc = t2[3]), this.tryEntries.push(e2);
    }
    function resetTryEntry(t2) {
      var e2 = t2.completion || {};
      e2.type = "normal", delete e2.arg, t2.completion = e2;
    }
    function Context(t2) {
      this.tryEntries = [{
        tryLoc: "root"
      }], t2.forEach(pushTryEntry, this), this.reset(true);
    }
    function values(e2) {
      if (e2 || "" === e2) {
        var r2 = e2[a];
        if (r2)
          return r2.call(e2);
        if ("function" == typeof e2.next)
          return e2;
        if (!isNaN(e2.length)) {
          var o2 = -1, i2 = function next() {
            for (; ++o2 < e2.length; )
              if (n.call(e2, o2))
                return next.value = e2[o2], next.done = false, next;
            return next.value = t, next.done = true, next;
          };
          return i2.next = i2;
        }
      }
      throw new TypeError(typeof e2 + " is not iterable");
    }
    return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
      value: GeneratorFunctionPrototype,
      configurable: true
    }), o(GeneratorFunctionPrototype, "constructor", {
      value: GeneratorFunction,
      configurable: true
    }), GeneratorFunction.displayName = define2(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function(t2) {
      var e2 = "function" == typeof t2 && t2.constructor;
      return !!e2 && (e2 === GeneratorFunction || "GeneratorFunction" === (e2.displayName || e2.name));
    }, e.mark = function(t2) {
      return Object.setPrototypeOf ? Object.setPrototypeOf(t2, GeneratorFunctionPrototype) : (t2.__proto__ = GeneratorFunctionPrototype, define2(t2, u, "GeneratorFunction")), t2.prototype = Object.create(g), t2;
    }, e.awrap = function(t2) {
      return {
        __await: t2
      };
    }, defineIteratorMethods(AsyncIterator.prototype), define2(AsyncIterator.prototype, c, function() {
      return this;
    }), e.AsyncIterator = AsyncIterator, e.async = function(t2, r2, n2, o2, i2) {
      void 0 === i2 && (i2 = Promise);
      var a2 = new AsyncIterator(wrap(t2, r2, n2, o2), i2);
      return e.isGeneratorFunction(r2) ? a2 : a2.next().then(function(t3) {
        return t3.done ? t3.value : a2.next();
      });
    }, defineIteratorMethods(g), define2(g, u, "Generator"), define2(g, a, function() {
      return this;
    }), define2(g, "toString", function() {
      return "[object Generator]";
    }), e.keys = function(t2) {
      var e2 = Object(t2), r2 = [];
      for (var n2 in e2)
        r2.push(n2);
      return r2.reverse(), function next() {
        for (; r2.length; ) {
          var t3 = r2.pop();
          if (t3 in e2)
            return next.value = t3, next.done = false, next;
        }
        return next.done = true, next;
      };
    }, e.values = values, Context.prototype = {
      constructor: Context,
      reset: function(e2) {
        if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = false, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e2)
          for (var r2 in this)
            "t" === r2.charAt(0) && n.call(this, r2) && !isNaN(+r2.slice(1)) && (this[r2] = t);
      },
      stop: function() {
        this.done = true;
        var t2 = this.tryEntries[0].completion;
        if ("throw" === t2.type)
          throw t2.arg;
        return this.rval;
      },
      dispatchException: function(e2) {
        if (this.done)
          throw e2;
        var r2 = this;
        function handle(n2, o3) {
          return a2.type = "throw", a2.arg = e2, r2.next = n2, o3 && (r2.method = "next", r2.arg = t), !!o3;
        }
        for (var o2 = this.tryEntries.length - 1; o2 >= 0; --o2) {
          var i2 = this.tryEntries[o2], a2 = i2.completion;
          if ("root" === i2.tryLoc)
            return handle("end");
          if (i2.tryLoc <= this.prev) {
            var c2 = n.call(i2, "catchLoc"), u2 = n.call(i2, "finallyLoc");
            if (c2 && u2) {
              if (this.prev < i2.catchLoc)
                return handle(i2.catchLoc, true);
              if (this.prev < i2.finallyLoc)
                return handle(i2.finallyLoc);
            } else if (c2) {
              if (this.prev < i2.catchLoc)
                return handle(i2.catchLoc, true);
            } else {
              if (!u2)
                throw Error("try statement without catch or finally");
              if (this.prev < i2.finallyLoc)
                return handle(i2.finallyLoc);
            }
          }
        }
      },
      abrupt: function(t2, e2) {
        for (var r2 = this.tryEntries.length - 1; r2 >= 0; --r2) {
          var o2 = this.tryEntries[r2];
          if (o2.tryLoc <= this.prev && n.call(o2, "finallyLoc") && this.prev < o2.finallyLoc) {
            var i2 = o2;
            break;
          }
        }
        i2 && ("break" === t2 || "continue" === t2) && i2.tryLoc <= e2 && e2 <= i2.finallyLoc && (i2 = null);
        var a2 = i2 ? i2.completion : {};
        return a2.type = t2, a2.arg = e2, i2 ? (this.method = "next", this.next = i2.finallyLoc, y) : this.complete(a2);
      },
      complete: function(t2, e2) {
        if ("throw" === t2.type)
          throw t2.arg;
        return "break" === t2.type || "continue" === t2.type ? this.next = t2.arg : "return" === t2.type ? (this.rval = this.arg = t2.arg, this.method = "return", this.next = "end") : "normal" === t2.type && e2 && (this.next = e2), y;
      },
      finish: function(t2) {
        for (var e2 = this.tryEntries.length - 1; e2 >= 0; --e2) {
          var r2 = this.tryEntries[e2];
          if (r2.finallyLoc === t2)
            return this.complete(r2.completion, r2.afterLoc), resetTryEntry(r2), y;
        }
      },
      catch: function(t2) {
        for (var e2 = this.tryEntries.length - 1; e2 >= 0; --e2) {
          var r2 = this.tryEntries[e2];
          if (r2.tryLoc === t2) {
            var n2 = r2.completion;
            if ("throw" === n2.type) {
              var o2 = n2.arg;
              resetTryEntry(r2);
            }
            return o2;
          }
        }
        throw Error("illegal catch attempt");
      },
      delegateYield: function(e2, r2, n2) {
        return this.delegate = {
          iterator: values(e2),
          resultName: r2,
          nextLoc: n2
        }, "next" === this.method && (this.arg = t), y;
      }
    }, e;
  }
  function _toPrimitive(t, r) {
    if ("object" != typeof t || !t)
      return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
      var i = e.call(t, r || "default");
      if ("object" != typeof i)
        return i;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
  }
  function _toPropertyKey(t) {
    var i = _toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
  }
  function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
      var info = gen[key](arg);
      var value = info.value;
    } catch (error) {
      reject(error);
      return;
    }
    if (info.done) {
      resolve(value);
    } else {
      Promise.resolve(value).then(_next, _throw);
    }
  }
  function _asyncToGenerator(fn) {
    return function() {
      var self = this, args = arguments;
      return new Promise(function(resolve, reject) {
        var gen = fn.apply(self, args);
        function _next(value) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
        }
        function _throw(err) {
          asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
        }
        _next(void 0);
      });
    };
  }
  function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
      throw new TypeError("Cannot call a class as a function");
    }
  }
  function _defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor)
        descriptor.writable = true;
      Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor);
    }
  }
  function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps)
      _defineProperties(Constructor.prototype, protoProps);
    if (staticProps)
      _defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
      writable: false
    });
    return Constructor;
  }
  function _defineProperty(obj, key, value) {
    key = _toPropertyKey(key);
    if (key in obj) {
      Object.defineProperty(obj, key, {
        value,
        enumerable: true,
        configurable: true,
        writable: true
      });
    } else {
      obj[key] = value;
    }
    return obj;
  }
  var EHandlerType = /* @__PURE__ */ function(EHandlerType2) {
    EHandlerType2["TIME_TRAKER"] = "timetracker";
    return EHandlerType2;
  }(EHandlerType || {});
  var isEnabledLog = function isEnabledLog2(debugQueryParam) {
    var url = new URL(window.location.href);
    return url.searchParams.get(debugQueryParam) === "1";
  };
  var getDebugQueryParam = function getDebugQueryParam2(handlerType) {
    return "spletnik.debug_".concat(handlerType);
  };
  var isBrowser = function isBrowser2() {
    try {
      return typeof window !== "undefined";
    } catch (e) {
      return false;
    }
  };
  var getLogger = function getLogger2(handlerType) {
    return isBrowser() && isEnabledLog(getDebugQueryParam(handlerType)) ? function(msg, options) {
      return (
        // eslint-disable-next-line no-console
        console.log("[spletnik.".concat(handlerType, "]: ").concat(msg), options !== null && options !== void 0 ? options : "")
      );
    } : function() {
      return null;
    };
  };
  var DEFAULT_RETRY_TIMEOUT = 1e4;
  var DEFAULT_MAX_FAILED_ATTEMPTS = 1;
  var MS_IN_SEC = 1e3;
  var log$1 = getLogger(EHandlerType.TIME_TRAKER);
  var TimeTracker = /* @__PURE__ */ function() {
    function TimeTracker2(params) {
      _classCallCheck(this, TimeTracker2);
      _defineProperty(this, "url", "");
      _defineProperty(this, "xemail", "");
      _defineProperty(this, "mna", 0);
      _defineProperty(this, "mnb", 0);
      _defineProperty(this, "retryTimeout", DEFAULT_RETRY_TIMEOUT);
      _defineProperty(this, "maxFailedAttempts", DEFAULT_MAX_FAILED_ATTEMPTS);
      _defineProperty(this, "timeout", -1);
      _defineProperty(this, "failedAttempts", 0);
      _defineProperty(this, "hasDelayedRequest", false);
      log$1("constructor options:", params);
      var global = window;
      if (!params.enabled || global[TimeTracker2.name]) {
        return;
      }
      this.url = params.url;
      this.xemail = params.xemail;
      this.mna = params.mna;
      this.mnb = params.mnb;
      this.retryTimeout = params.retryTimeout;
      this.maxFailedAttempts = params.maxFailedAttempts;
      global[TimeTracker2.name] = true;
      this.listenTabActivity();
      this.listenForNavigation();
      void this.send();
    }
    return _createClass(TimeTracker2, [{
      key: "listenTabActivity",
      value: function listenTabActivity() {
        var _this = this;
        document.addEventListener("visibilitychange", function() {
          if (_this.hasDelayedRequest) {
            log$1("delayed request was sent after the tab became active");
            void _this.send();
          }
        });
      }
    }, {
      key: "listenForNavigation",
      value: function listenForNavigation() {
        var _this2 = this;
        var previousUrl = window.location.href;
        var observer = new MutationObserver(function() {
          if (window.location.href !== previousUrl) {
            log$1("location has changed, sending the request now");
            window.clearTimeout(_this2.timeout);
            void _this2.send();
            previousUrl = window.location.href;
          }
        });
        observer.observe(document, {
          subtree: true,
          childList: true
        });
      }
    }, {
      key: "send",
      value: function() {
        var _send = _asyncToGenerator(/* @__PURE__ */ _regeneratorRuntime().mark(function _callee() {
          var queryParams, response, responseJSON;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1)
              switch (_context.prev = _context.next) {
                case 0:
                  if (!document.hidden) {
                    _context.next = 4;
                    break;
                  }
                  log$1("request was delayed since the tab is inactive");
                  this.hasDelayedRequest = true;
                  return _context.abrupt("return");
                case 4:
                  _context.prev = 4;
                  queryParams = this.xemail ? new URLSearchParams({
                    xemail: this.xemail,
                    mna: this.mna.toString(),
                    mnb: this.mnb.toString()
                  }) : "";
                  log$1("sending request:", queryParams.toString());
                  _context.next = 9;
                  return fetch(this.url + (queryParams ? "?".concat(queryParams.toString()) : ""));
                case 9:
                  response = _context.sent;
                  _context.next = 12;
                  return response.json();
                case 12:
                  responseJSON = _context.sent;
                  this.hasDelayedRequest = false;
                  this.failedAttempts = 0;
                  log$1("response json:", responseJSON);
                  if (responseJSON.recallAfter > 0) {
                    log$1("next request is scheduled in (ms):", responseJSON.recallAfter);
                    this.scheduleARequest(responseJSON.recallAfter * MS_IN_SEC);
                  } else {
                    log$1("next request is not scheduled (server)");
                  }
                  _context.next = 26;
                  break;
                case 19:
                  _context.prev = 19;
                  _context.t0 = _context["catch"](4);
                  this.hasDelayedRequest = false;
                  this.failedAttempts += 1;
                  if (this.failedAttempts < this.maxFailedAttempts) {
                    log$1("the request is scheduled to retry in (ms):", this.retryTimeout);
                    this.scheduleARequest(this.retryTimeout);
                  } else {
                    log$1("next request is not scheduled (reached maxFailedAttempts)");
                  }
                  log$1("failed with:", _context.t0);
                  console.error("TimeTracker stat was not sent: ".concat(_context.t0.toString()));
                case 26:
                case "end":
                  return _context.stop();
              }
          }, _callee, this, [[4, 19]]);
        }));
        function send() {
          return _send.apply(this, arguments);
        }
        return send;
      }()
    }, {
      key: "scheduleARequest",
      value: function scheduleARequest(ms) {
        this.timeout = window.setTimeout(this.send.bind(this), ms);
      }
    }]);
  }();
  var MAIN_LOG_LEVEL = "main";
  var HANDLERS = _defineProperty({}, EHandlerType.TIME_TRAKER, TimeTracker);
  var CONFIG_EL_ATTR = "data-spletnik-config";
  var HANDLED_CONFIG_ATTR = "data-inited";
  var NOT_HANDLED_CONFIG_SELECTOR = "[".concat(CONFIG_EL_ATTR, "]:not([").concat(HANDLED_CONFIG_ATTR, "])");
  var log = getLogger(MAIN_LOG_LEVEL);
  var parseConfig = function parseConfig2(el) {
    try {
      var config = JSON.parse(el.innerHTML);
      log("handler config found:", config);
      return config;
    } catch (error) {
      console.error("Error while parsing spletnik config: ".concat(error.toString()));
      return null;
    }
  };
  try {
    if (isBrowser()) {
      var configs = document.querySelectorAll(NOT_HANDLED_CONFIG_SELECTOR);
      configs.forEach(function(el) {
        var config = parseConfig(el);
        var Handler = config && HANDLERS[config.type];
        if (Handler) {
          log("handler found for config:", Handler.name);
          new Handler(config.params);
          el.setAttribute(HANDLED_CONFIG_ATTR, "");
        }
      });
    }
  } catch (error) {
    console.error("Error while spletnik initialization: ".concat(error.toString()));
  }
});
